import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RpaServices } from "../../services/RpaServices";
import DatePicker from "react-datepicker";
import EditStatusModal from "./editCases/EditStatusModal";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { CaseServices } from "../../services/CaseServices";
import { CircularProgress } from "@mui/material";
import { AuthServices } from "../../services/AuthServices";
import downloadPdf from "../../utils/downloadPdfUtil";
import { ReactComponent as TickIcon } from "../../assets/Tick.svg";
import { ReactComponent as SideArrow } from "../../assets/SideArrow.svg";
import { ReactComponent as NotUploaded } from "../../assets/docNotUploaded.svg";
import CloseIcon from "../../assets/crossIcon.svg";
import QueryTmsDocumentModal from "./QueryTmsDocumentModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ReactComponent as CrosIcon } from "../../assets/CrosIcon.svg";
import SelectedCrossIcon from "../../assets/cross-icon-selected.png";
import { toast } from "react-toastify";
//testing deployment
function TmsQueries({
  caseId,
  setEditStatus,
  AllCases,
  showClose,
  patientName,
  hospitalName,
  tmsVersion,
  registrationId,
  onCloseModal,
  fetchQueries,
  fetchCaseQueryCounts,
}) {
  const [mappedDocuments, setMappedDocuments] = useState(null);
  const [documentDownloading, setDocumentDownloading] = useState(null);
  const [documentType, setDocumentType] = useState("LATESTDOCUMENTS");
  const [pdfDocName, setPdfDocName] = useState("");
  const [processingPdf, setProcessingPdf] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [netSpeed, setNetSpeed] = useState(0);

  const [mergeDocumentDownloading, setMergeDocumentDownloading] =
    useState(null);
  const [documentSubDownloading, setDocumentSubDownloading] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [latestStageSelectedDocs, setLatestStageSelectedDocs] = useState([]);
  const [pdfList, setPdfList] = useState([]);
  const [queryDocModalOpen, setQueryDocModalOpen] = useState(false);
  const [queryDocInitial, setQueryDocInitial] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [queries, setQueries] = useState([]);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [queryIds, setQueryIds] = useState(null);
  const [latestStage, setLatestStage] = useState(null);
  const [latestStageDocuments, setLatestStageDocuments] = useState(null);
  const [docCounts, setDocCounts] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [referenceTab, setReferenceTab] = useState(false);
  const navigate = useNavigate();
  const latestDocumentType =
    latestStage?.documents?.[0]?.documentType?.toUpperCase();

  const isLatestStageDocument = (documentKey) => {
    return documentKey?.toUpperCase() === latestDocumentType;
  };
  const getAllQueries = async () => {
    try {
      const response = await RpaServices.getTmsQueries(caseId);
      setQueries(response.data.queries);
      setQueryIds(response.data.queries.map((query) => query.id));
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  function formatDate(dateString) {
    const date = new Date(dateString);

    const pad = (num) => String(num).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = pad(date.getMinutes());

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert 0 -> 12

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  }
  const getLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(caseId);
      console.log("response: ", response.data);
      if (response?.data?.currnetSubMasterStage[0]) {
        // setLatestStage(response?.data?.currnetSubMasterStage[0]?.hsaStage);
        setLatestStage(response?.data);
        setLatestStageDocuments(
          response?.data?.documents?.map((doc) => {
            return { ...doc, isSelected: false };
          }),
        );
        // setLatestEnhancement(response?.data?.latestEnhancement);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDocCounts = async () => {
    try {
      const res = await CaseServices.getDocumentCount(caseId);
      console.log("response: ", res.data);
      setDocCounts(res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    //getMappedDocuments();
    getLatestCaseStage();
    getDocCounts();
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleRemoveSelectedDocument = (docId) => {
    // Remove from selectedDocuments
    setSelectedDocuments((prev) => prev.filter((doc) => doc.id !== docId));

    // Uncheck from mappedDocuments
    const updatedDocuments = mappedDocuments.map((document) => ({
      ...document,
      value: document.value.map((doc) =>
        doc.id === docId ? { ...doc, isSelected: false } : doc,
      ),
    }));

    setMappedDocuments(updatedDocuments);
  };

  const getMappedDocuments = async () => {
    try {
      const response = await CaseServices.getMappedDocuments(
        caseId,
        documentType,
      );
      console.log("mapped dcuments:", response?.data);
      let data = [];
      for (let docType in response.data.mappedDocuments) {
        let keyData = response.data.mappedDocuments[docType];
        keyData = keyData.map((doc) => {
          return { ...doc, isSelected: false };
        });

        // Check if this is an Enhancement document type
        const isEnhancement = docType.toUpperCase().includes("ENHANCEMENT");

        if (isEnhancement) {
          // Descending order for Enhancement documents (3, 2, 1)
          keyData.sort((a, b) => {
            return b.documentName.localeCompare(a.documentName, undefined, {
              numeric: true,
              sensitivity: "base",
            });
          });
        } else {
          // Ascending order for all other documents (1, 2, 3)
          keyData.sort((a, b) => {
            return a.documentName.localeCompare(b.documentName, undefined, {
              numeric: true,
              sensitivity: "base",
            });
          });
        }

        data.push({
          key: docType,
          value: keyData,
        });
      }

      // Custom sort for parent array
      data.sort((a, b) => {
        // Check if both are enhancement types
        const aIsEnhancement = a.key.toUpperCase().includes("ENHANCEMENT");
        const bIsEnhancement = b.key.toUpperCase().includes("ENHANCEMENT");

        // If both are enhancements, sort them in descending order (ENHANCEMENT2 before ENHANCEMENT1)
        if (aIsEnhancement && bIsEnhancement) {
          return b.key.localeCompare(a.key, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        }

        // Otherwise, use normal ascending sort
        return a.key.localeCompare(b.key, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });

      setMappedDocuments(data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const generatePDFUsingPython = async (images, documentName) => {
    const imagesUrl = images.map((image) => ({
      image: image.documentUrl,
      compressionPossible: true,
    }));

    if (imagesUrl.length > 0) {
      try {
        const targetSize = tmsVersion === "1.0" ? 1200 : 1800;
        let response = await AuthServices.loadImagesBase64UsingPython(
          { images: imagesUrl },
          setPercentage,
          setNetSpeed,
          targetSize,
        );

        downloadPdf(
          response.data,
          `${documentName}`,
          registrationId,
          patientName,
          hospitalName,
        );
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      toast.error("No Document Uploaded Yet");
    }
    setDocumentDownloading(null);
    setMergeDocumentDownloading(null);
    setDocumentSubDownloading(null);
  };

  const handleLatestDocSelection = (docId) => {
    //Find already selected document
    const idx = latestStageSelectedDocs?.findIndex((item) => item.id === docId);
    if (idx !== -1) {
      //remove already present document
      let modifiedData = latestStageSelectedDocs;
      modifiedData.splice(idx, 1);
      setLatestStageSelectedDocs(modifiedData);
    } else {
      //Add if document is not present
      let selectedDoc = latestStageDocuments.find((item) => item.id === docId);
      if (selectedDoc) {
        setLatestStageSelectedDocs([...latestStageSelectedDocs, selectedDoc]);
      }
    }
  };
  const handleSelectedDoc = (docId) => {
    //Find already selected document
    const idx = selectedDocuments?.findIndex((item) => item.id === docId);
    if (idx !== -1) {
      //remove already present document
      let modifiedData = selectedDocuments;
      modifiedData.splice(idx, 1);
      setSelectedDocuments(modifiedData);
    } else {
      //Add if document is not present
      for (let doc of mappedDocuments) {
        let selectedDoc = doc.value.find((item) => item.id === docId);
        if (selectedDoc) {
          setSelectedDocuments([...selectedDocuments, selectedDoc]);
          break;
        }
      }
    }
  };
  const handleSelection = (key, idx) => {
    const modifiedData = mappedDocuments?.map((doc) => {
      if (key === doc.key) {
        doc.value[idx].isSelected = !doc.value[idx].isSelected;
      }
      return doc;
    });
    setMappedDocuments(modifiedData);
  };
  const handleMultipleDownloads = (documentsData) => {
    for (let doc of documentsData) {
      generatePDFUsingPython(doc?.documenturlmasters, doc?.documentName);
    }
  };

  const handleMergeClick = (value, key) => {
    let urlData = [];
    for (let doc of value) {
      if (doc.isSelected) {
        urlData = [...urlData, ...doc.documenturlmasters];
      }
    }
    if (urlData.length > 0) {
      generatePDFUsingPython(urlData, `merged ${key}`);
    } else {
      toast.error("Please select atleat one document");
    }
  };

  const buildMappedQueryDocumentsPayload = () => {
    if (!selectedDocuments?.length) {
      toast.error("Please select at least one document");
      return null;
    }

    const latestDocument = latestStage?.documents?.[0];

    if (!latestDocument) {
      toast.error("Latest stage details not found");
      return null;
    }

    const latestStageDocumentNames = (latestStage?.documents || []).map((doc) =>
      doc?.documentName?.trim()?.toLowerCase(),
    );

    const alreadyMappedDocument = selectedDocuments.find((doc) =>
      latestStageDocumentNames.includes(
        doc?.documentName?.trim()?.toLowerCase(),
      ),
    );

    if (alreadyMappedDocument) {
      toast.error("This document is already mapped");
      return null;
    }

    const isEnhancementStage = latestStage?.currnetSubMasterStage?.[0]?.hsaStage
      ?.toLowerCase()
      ?.includes("enhancement");

    const documents = selectedDocuments
      .filter(
        (doc) =>
          Array.isArray(doc?.documenturlmasters) &&
          doc.documenturlmasters.length > 0,
      )
      .map((doc) => ({
        caseId,

        documentType: latestDocument.documentType,

        documentName: doc.documentName,

        ...(isEnhancementStage && {
          enhancementId: latestDocument.enhancementId,
        }),

        status: "APPROVED",

        documenturlmasters: doc.documenturlmasters.map(
          ({ id, referenceDocumentId, ...rest }) => rest,
        ),
      }));

    if (!documents.length) {
      toast.error("Selected documents have no valid attachments");
      return null;
    }

    return { documents };
  };

  const handleMapDocuments = async () => {
    const payload = buildMappedQueryDocumentsPayload();

    if (!payload) return false;

    try {
      const res = await CaseServices.mapSaveQueryDocuments(payload);
      setDocumentType("LATESTDOCUMENTS");
      await getLatestCaseStage();
      toast.success(res?.data?.message);

      return true;
    } catch (error) {
      handleApiErrorResponses(error);
      return false;
    }
  };

  const admissionCount =
    docCounts?.docCount?.find(
      (item) => item?.documentType === "ADMISSIONDOCUMENT",
    )?.count || 0;

  const enhancementDocCount =
    docCounts?.docCount?.find((item) => item?.documentType === "ENHANCEMENT")
      ?.count || 0;

  const dischargeCount =
    docCounts?.docCount?.find(
      (item) => item?.documentType === "ONDISCHARGEDOCUMENT",
    )?.count || 0;

  const generatePdfList = async () => {
    setProcessingPdf(true);

    let imagesUrl = [];

    for (let doc of selectedDocuments) {
      for (let image of doc?.documenturlmasters || []) {
        if (image?.documentUrl) {
          imagesUrl.push({
            image: image.documentUrl,
            compressionPossible: true,
          });
        }
      }
    }

    if (imagesUrl.length > 0) {
      try {
        const targetSize = tmsVersion === "1.0" ? 1024 : 1050;

        let response = await AuthServices.loadImagesBase64UsingPython(
          { images: imagesUrl },
          setPercentage,
          setNetSpeed,
          targetSize,
        );

        // Existing state logic preserved
        setPdfList([
          ...pdfList,
          {
            docName: pdfDocName,
            pdfBlob: response?.data,
          },
        ]);

        // ONLY NEW ADDITION
        downloadPdf(
          response.data,
          pdfDocName,
          registrationId,
          patientName,
          hospitalName,
        );

        setPdfDocName("");
        setSelectedDocuments([]);

        // Reset selected docs
        let data = mappedDocuments.map((doc) => {
          doc.value = doc.value?.map((item) => {
            return { ...item, isSelected: false };
          });

          return { ...doc };
        });

        setMappedDocuments([...data]);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      toast.error("No Document Uploaded Yet");
    }

    setProcessingPdf(false);
  };

  useEffect(() => {
    getMappedDocuments();
  }, [documentType]);
  useEffect(() => {
    getAllQueries();
  }, []);

  return (
    <div className="relative p-6 w-full h-full overflow-y-auto">
      {" "}
      <div className="sticky -top-7 z-10 flex items-center justify-between mb-4 bg-white">
        <h1 className="font-[Lufga] font-medium text-[20px] xl:text-[24px] 2xl:text-[24px] leading-[100%] tracking-[0em] text-[#191919]">
          TMS Queries
        </h1>

        <>
          <div className="flex items-center gap-3">
            <span
              className="w-[148px] h-[39px] xl:w-[167px] xl:h-[42px] 2xl:w-[167px] 2xl:h-[42px] text-white border border-white bg-[#017C57] rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-normal text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center"
              onClick={() =>
                navigate("/Dashboard/EditCases", {
                  state: {
                    selectedCase: { id: caseId },
                    tab: "DOWNLOAD DOCUMENTS",
                  },
                })
              }
            >
              View Complete Details
            </span>
            <div>
              <CrosIcon
                className="cursor-pointer"
                onClick={() => {
                  if (onCloseModal) {
                    onCloseModal();
                  }

                  if (setEditStatus) {
                    setEditStatus(false);
                  }
                }}
              />
            </div>
          </div>
        </>
      </div>
      <div className="pr-2 pb-6">
        {" "}
        <div className="grid md:grid-cols-[2fr_7fr_1fr] text-[#191919]  px-8 py-1 gap-4 justify-between w-full font-[Lufga] mt-4">
          <div>Date</div>
          <div>Query </div>
          <div>Query Status</div>
        </div>
        <div className="my-2">
          {queries.length > 0 ? (
            queries.map((query, index) => (
              <div
                key={index}
                className={`grid md:grid-cols-[2fr_7fr_1fr] py-1 px-8 text-[#797979] text-[16px] w-full mt-1 font-[Lufga] ${
                  index % 2 === 0 ? "bg-white" : "bg-[#f5f5f5]"
                }`}
              >
                <div className="border-none  w-full text-black">
                  {formatDate(query.createdAt)}
                </div>
                <div className="max-w-[550px] xl:max-w-[650px] 2xl:max-w-[750px] 3xl:max-w-[950px] text-black text-[14px] font-[Lufga] leading-5 break-words whitespace-normal text-left">
                  {query.queryMessage}
                </div>
                <div className="text-black text-[14px] font-medium">
                  {query.status}
                </div>
              </div>
            ))
          ) : (
            <div className="p-4 text-center text-[#797979]">
              No queries available
            </div>
          )}
        </div>
        <div
          style={{
            borderBottom: "1px solid #E4E4E4",
            marginBlock: "20px",
          }}
        />
        <div className="flex gap-4 border-[1px] border-green-700 rounded-full p-1 mt-6">
          <div
            onClick={() => setDocumentType("LATESTDOCUMENTS")}
            className={`w-[156px] h-[39px] xl:w-[172px] xl:h-[42px] 2xl:w-[172px] 2xl:h-[42px] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]/60 ${
              documentType === "LATESTDOCUMENTS"
                ? "bg-[#017C57] text-white"
                : "text-[#017C57]"
            }`}
          >
            {`Mapped Documents ( ${latestStageDocuments?.length || 0} )`}
          </div>
          <div
            onClick={() => setDocumentType("ADMISSIONDOCUMENT")}
            className={`w-[113px] h-[42px] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-medium text-[14px] leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]/60 ${
              documentType === "ADMISSIONDOCUMENT"
                ? "bg-[#017C57] text-white"
                : "text-[#017C57]"
            }`}
          >
            Admission ( {admissionCount} )
          </div>

          <div
            onClick={() =>
              setDocumentType(
                latestStage?.documents[0]?.documentType?.includes("ENHANCEMENT")
                  ? latestStage?.documents[0]?.documentType
                  : `ENHANCEMENT${docCounts?.enhancementCount}`,
              )
            }
            className={`w-[130px] h-[39px] xl:w-[146px] xl:h-[42px] 2xl:w-[146px] 2xl:h-[42px] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]/60 ${
              documentType.includes("ENHANCEMENT") ||
              documentType?.includes("DURINGTREATMENTDOCUMENT")
                ? "bg-[#017C57] text-white"
                : "text-[#017C57]"
            }`}
          >
            Enhancement( {enhancementDocCount}/
            {docCounts?.enhancementCount || 0} )
          </div>

          <div
            onClick={() => setDocumentType("ONDISCHARGEDOCUMENT")}
            className={`w-[132px] h-[39px] xl:w-[148px] xl:h-[42px] 2xl:w-[148px] 2xl:h-[42px] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]/60 ${
              documentType === "ONDISCHARGEDOCUMENT"
                ? "bg-[#017C57] text-white"
                : "text-[#017C57]"
            }`}
          >
            Discharge/Claim( {dischargeCount} )
          </div>
          <div
            onClick={() => setDocumentType("")}
            className={`w-[80px] h-[39px] xl:h-[42px] 2xl:h-[42px] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]/60 ${
              documentType === "" ? "bg-[#017C57] text-white" : "text-[#017C57]"
            }`}
          >
            All
          </div>

          <div
            onClick={() => {
              setQueryDocModalOpen(true);
              setReferenceTab(true);
            }}
            className="ml-auto w-[159px] h-[39px] xl:w-[180px] xl:h-[42px] 2xl:w-[180px] 2xl:h-[42px] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] whitespace-nowrap flex items-center justify-center text-center border border-solid border-[#017C57]"
          >
            Reference Documents
          </div>
        </div>
        {documentType === "LATESTDOCUMENTS" ? (
          <div>
            <div className="flex justify-between items-center mt-6 mb-4">
              <div className="font-[Lufga] font-medium text-[20px] xl:text-[24px] 2xl:text-[24px] leading-[100%] tracking-[0em] text-[#191919]">
                Mapped Documents
              </div>
              {latestStageDocuments?.length > 0 &&
                (documentDownloading ? (
                  <CircularProgress />
                ) : (
                  <div className="flex gap-4">
                    <div
                      className="w-[207px] h-[39px] xl:w-[236px] xl:h-[42px] 2xl:w-[236px] 2xl:h-[42px] flex gap-[10px] items-center justify-center border border-solid border-[#017C57]/60 rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] text-center whitespace-nowrap"
                      onClick={() => setQueryDocModalOpen(true)}
                    >
                      View All Mapped Documents
                    </div>

                    <div
                      className="w-[207px] h-[39px] xl:w-[236px] xl:h-[42px] 2xl:w-[236px] 2xl:h-[42px] flex gap-[10px] items-center justify-center border border-solid border-[#017C57]/60 rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] text-center whitespace-nowrap"
                      onClick={() => {
                        // setDocumentDownloading(idx);
                        handleMultipleDownloads(latestStageDocuments);
                      }}
                    >
                      <FileDownloadOutlinedIcon className="w-5 h-5" />
                      All Mapped Documents
                    </div>
                    <div
                      className="w-[207px] h-[39px] xl:w-[236px] xl:h-[42px] 2xl:w-[236px] 2xl:h-[42px] flex gap-[10px] items-center justify-center border border-solid border-[#017C57]/60 rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] text-center whitespace-nowrap"
                      onClick={() => {
                        // setMergeDocumentDownloading(idx);
                        handleMergeClick(latestStageDocuments, "latest_stage");
                      }}
                    >
                      Merge Mapped Documents
                    </div>
                  </div>
                ))}
            </div>
            <div className="grid xl:grid-cols-3  gap-5">
              {latestStageDocuments?.map((doc, index) => {
                return (
                  <div
                    key={index}
                    style={{ border: "1.5px solid #E4E4E4" }}
                    className={`h-[105px] flex flex-col justify-between rounded-[38px] p-6 ${doc.documenturlmasters.length == 0 ? "bg-[#E8E8E899]" : ""}`}
                  >
                    <div className={`flex justify-between items-center`}>
                      <div className="overflow-hidden  flex gap-2 items-start">
                        {/* {doc.documenturlmasters.length > 0 ? (
                          <div
                            className={`w-12 h-12 min-w-[48px] min-h-[48px] flex-shrink-0 flex items-center justify-center rounded-full cursor-pointer 
  ${doc.isSelected ? "" : "border-gray-400 border-solid rounded-full"}`}
                            onClick={() => {
                              // handleSelection(document.key, index);
                              latestStageDocuments[index].isSelected =
                                !latestStageDocuments[index].isSelected;

                              setLatestStageDocuments([
                                ...latestStageDocuments,
                              ]);

                              handleLatestDocSelection(doc.id);
                            }}
                          >
                            {doc.isSelected && (
                              <TickIcon className="w-27 h-24 text-white " />
                            )}
                          </div>
                        ) : (
                          <NotUploaded />
                        )} */}
                        <div
                          className={`w-12 h-12 min-w-[48px] min-h-[48px] flex-shrink-0 flex items-center justify-center rounded-full cursor-pointer 
  ${doc.isSelected ? "" : "border-gray-400 border-solid rounded-full"}`}
                          onClick={() => {
                            // handleSelection(document.key, index);
                            latestStageDocuments[index].isSelected =
                              !latestStageDocuments[index].isSelected;

                            setLatestStageDocuments([...latestStageDocuments]);

                            handleLatestDocSelection(doc.id);
                          }}
                        >
                          {doc.isSelected && (
                            <TickIcon className="w-27 h-24 text-white " />
                          )}
                        </div>
                        <div className="w-full h-full overflow-hidden text-ellipsis line-clamp-3 font-[Lufga] font-normal text-[12px] xl:text-[16px] 2xl:text-[16px] leading-[100%] tracking-[0em] align-middle text-[#1B1B1B]">
                          {doc.documentName}
                        </div>
                      </div>
                      <div className="flex shrink-0 items-center">
                        {doc.documenturlmasters.length > 0 && (
                          <div
                            onClick={() => {
                              setQueryDocInitial(doc);
                              setQueryDocModalOpen(true);
                            }}
                            className="flex items-center cursor-pointer text-sm font-semibold underline underline-offset-1"
                            // role="button"
                            tabIndex={0}
                          >
                            View
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <EditStatusModal
              setEditStatus={setEditStatus}
              caseId={caseId}
              queryIds={queryIds}
              documents={mappedDocuments}
              AllCases={AllCases}
              latestStageSelectedDocs={latestStageSelectedDocs}
              selectedDocuments={selectedDocuments}
              latestStage={latestStage}
              setSelectedDocuments={setLatestStageSelectedDocs}
              fetchQueries={fetchQueries}
              fetchCaseQueryCounts={fetchCaseQueryCounts}
              getLatestCaseStage={getLatestCaseStage}
            />

            <QueryTmsDocumentModal
              open={queryDocModalOpen}
              onClose={() => {
                setQueryDocModalOpen(false);
                setReferenceTab(false);
              }}
              initialDocument={queryDocInitial}
              mappedDocuments={[
                {
                  key: latestStage?.documents[0]?.documentType,
                  // key: "MAPPED",
                  value: latestStageDocuments,
                },
              ]}
              caseId={caseId}
              latestStageDocuments={latestStageDocuments}
              getMappedDocuments={getMappedDocuments}
              getLatestCaseStage={getLatestCaseStage}
              referenceTab={referenceTab}
            />
          </div>
        ) : (
          <div>
            {mappedDocuments?.map((document, idx) => {
              return (
                (document?.key.includes(documentType) || documentType === "") &&
                document?.value?.length > 0 &&
                !document?.key.includes("DURING") && (
                  <div key={idx} className="mt-8">
                    <div className="flex justify-between mb-2">
                      <div className="font-[Lufga] font-medium text-[20px] xl:text-[24px] 2xl:text-[24px] leading-[100%] tracking-[0em] text-[#191919]">
                        {document?.key
                          ?.replace(/(DOCUMENT)/, " Documents")
                          .replace(/(ONDISCHARGE)/, "Discharge/Claim")
                          .replace(/(DURINGTREATMENT)/, "Enhancement ")
                          .replace(/(ENHANCEMENT)/, "Enhancement ")
                          .replace(/(ADMISSION)/, "Admission")
                          .replace(/^./, (c) => c.toUpperCase())
                          .replace(/\d+/g, (d) => d.padStart(2, "0"))}
                      </div>
                      {document?.value.length > 0 &&
                        (documentDownloading === idx ? (
                          <CircularProgress />
                        ) : (
                          <div className="flex gap-4">
                            <div
                              className="w-[207px] h-[39px] xl:w-[236px] xl:h-[42px] 2xl:w-[236px] 2xl:h-[42px] flex gap-[10px] items-center justify-center border border-solid border-[#017C57]/60 rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] text-center whitespace-nowrap"
                              onClick={() => {
                                setQueryDocModalOpen(true);
                                setQueryDocInitial(document?.value[0]);
                              }}
                            >
                              {`View All ${document.key
                                ?.replace(/(DOCUMENT)/, "")
                                ?.replace(/(ADMISSION)/, "Admission")
                                ?.replace(/(ONDISCHARGE)/, "Discharge/Claim")
                                ?.replace(/(DURINGTREATMENT)/, "Enhancement ")
                                ?.replace(
                                  /(ENHANCEMENT)/,
                                  "Enhancement ",
                                )} Documents`}
                            </div>

                            <div
                              className="w-[207px] h-[39px] xl:w-[236px] xl:h-[42px] 2xl:w-[236px] 2xl:h-[42px] flex gap-[10px] items-center justify-center border border-solid border-[#017C57]/60 rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] text-center whitespace-nowrap"
                              onClick={() => {
                                setDocumentDownloading(idx);
                                handleMultipleDownloads(document?.value);
                              }}
                            >
                              <FileDownloadOutlinedIcon className="w-5 h-5" />
                              {`All ${document.key
                                ?.replace(/(DOCUMENT)/, "")
                                ?.replace(/(ADMISSION)/, "Admission")
                                ?.replace(/(ONDISCHARGE)/, "Discharge/Claim")
                                ?.replace(/(DURINGTREATMENT)/, "Enhancement ")
                                ?.replace(
                                  /(ENHANCEMENT)/,
                                  "Enhancement ",
                                )} Documents`}
                            </div>
                            <div
                              className="w-[207px] h-[39px] xl:w-[236px] xl:h-[42px] 2xl:w-[236px] 2xl:h-[42px] flex gap-[10px] items-center justify-center border border-solid border-[#017C57]/60 rounded-[100px] px-4 py-[10px] cursor-pointer font-[Lufga] font-medium text-[12px] xl:text-[14px] 2xl:text-[14px] leading-[155%] tracking-[-0.07em] text-[#017C57] text-center whitespace-nowrap"
                              onClick={() => {
                                setMergeDocumentDownloading(idx);
                                handleMergeClick(
                                  document?.value,
                                  document?.key,
                                );
                              }}
                            >
                              {`Merge ${document.key
                                ?.replace(/(DOCUMENT)/, "")
                                ?.replace(/(ADMISSION)/, "Admission")
                                ?.replace(/(ONDISCHARGE)/, "Discharge/Claim")
                                ?.replace(/(DURINGTREATMENT)/, "Enhancement ")
                                ?.replace(
                                  /(ENHANCEMENT)/,
                                  "Enhancement ",
                                )} Documents`}
                            </div>
                          </div>
                        ))}
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid #E4E4E4",
                        marginBlock: "20px",
                      }}
                    />

                    {document?.value.length > 0 &&
                    !document?.key.includes("DURING") ? (
                      <div className="grid xl:grid-cols-3  gap-5">
                        {document?.value.map((doc, index) => {
                          const isLatestStageDoc = isLatestStageDocument(
                            document.key,
                          );
                          return (
                            <div
                              key={index}
                              style={{
                                border: "1.5px solid #E4E4E4",
                                backgroundColor: isLatestStageDocument(
                                  document.key,
                                )
                                  ? "#E8E8E899"
                                  : "#FFFFFF",
                              }}
                              className="h-[105px] flex flex-col justify-between rounded-[38px] p-6 "
                            >
                              <div className="flex justify-between items-center">
                                <div className="overflow-hidden  flex gap-2 items-start">
                                  {doc.documenturlmasters.length > 0 ? (
                                    <div
                                      className={`w-12 h-12 min-w-[48px] min-h-[48px] flex-shrink-0 flex items-center justify-center rounded-full
  ${isLatestStageDoc ? "cursor-not-allowed opacity-70" : "cursor-pointer"}
  ${
    doc.isSelected || isLatestStageDoc
      ? ""
      : "border-gray-400 border-solid rounded-full"
  }`}
                                      onClick={() => {
                                        if (isLatestStageDoc) return;

                                        handleSelection(document.key, index);
                                        handleSelectedDoc(doc.id);
                                      }}
                                    >
                                      {(doc.isSelected || isLatestStageDoc) && (
                                        <TickIcon className="w-27 h-24 text-white" />
                                      )}
                                    </div>
                                  ) : (
                                    <NotUploaded />
                                  )}
                                  <div className="w-full h-full overflow-hidden text-ellipsis line-clamp-3 font-[Lufga] font-normal text-[12px] xl:text-[16px] 2xl:text-[16px] leading-[100%] tracking-[0em] align-middle text-[#1B1B1B]">
                                    {doc.documentName}
                                  </div>
                                </div>
                                <div className="flex shrink-0 items-center">
                                  {doc.documenturlmasters.length > 0 && (
                                    <div
                                      onClick={() => {
                                        setQueryDocInitial(doc);
                                        setQueryDocModalOpen(true);
                                      }}
                                      className="flex items-center cursor-pointer text-sm font-semibold underline underline-offset-1"
                                      // role="button"
                                      tabIndex={0}
                                    >
                                      View
                                    </div>
                                  )}
                                </div>
                              </div>

                              {documentDownloading === idx ||
                              (mergeDocumentDownloading === idx &&
                                doc.isSelected) ||
                              documentSubDownloading === doc.id ? (
                                <CircularProgress />
                              ) : (
                                <div className="flex justify-between">
                                  {/* <div
                                  style={{ border: "1px solid #017C57" }}
                                  className="w-fit flex items-center gap-1 text-sm text-[#017C57] font-semibold bg-[white] rounded-full cursor-pointer px-4 py-2 border-[5px] z-10 "
                                  onClick={() => {
                                    setDocumentSubDownloading(doc?.id);
                                    generatePDFUsingPython(
                                      doc?.documenturlmasters,
                                      doc?.documentName
                                    );
                                  }}
                                >
                                  <img
                                    // src={DownloadIconGreen}
                                    alt="download-icon"
                                    height={14}
                                    width={14}
                                  />
                                  Download
                                </div> */}
                                  {/* {doc.documenturlmasters.length > 0 && (
                                <ReviewDocumentModel
                                  documentDetails={doc}
                                  type="view"
                                />
                              )} */}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center text-xl font-semibold pb-6  font-[Lufga]">
                        No Documents Mapped
                      </div>
                    )}
                  </div>
                )
              );
            })}
            <QueryTmsDocumentModal
              open={queryDocModalOpen}
              onClose={() => {
                setQueryDocModalOpen(false);
                setReferenceTab(false);
              }}
              initialDocument={queryDocInitial}
              mappedDocuments={mappedDocuments}
              caseId={caseId}
              latestStageDocuments={latestStageDocuments}
              getMappedDocuments={getMappedDocuments}
              getLatestCaseStage={getLatestCaseStage}
              referenceTab={referenceTab}
            />

            {selectedDocuments?.length > 0 && (
              <div className="max-h-[250px] sticky top-0  mt-1  z-[1204] overflow-y-auto">
                <div className="border border-solid border-[#E8E8E8] bg-white px-4 py-2 rounded-[28px]">
                  <div className="flex justify-between items-center">
                    <div className="font-semibold text-xl  font-[Lufga]">
                      Selected Documents
                    </div>
                  </div>

                  <div>
                    {selectedDocuments?.length > 0 &&
                      selectedDocuments?.map((doc, idx) => {
                        return (
                          <div
                            key={idx}
                            className="group flex items-center justify-between p-2 hover:bg-gray-100 rounded-md"
                          >
                            <div className="flex items-center gap-3">
                              <img
                                src={SelectedCrossIcon}
                                alt="remove"
                                className="w-3 h-3 cursor-pointer "
                                onClick={() =>
                                  handleRemoveSelectedDocument(doc.id)
                                }
                              />

                              <span className="font-[Lufga] font-medium text-[12px] xl:text-[16px] 2xl:text-[16px] leading-[100%] tracking-[0em] align-middle">
                                {idx + 1 + ". " + doc?.documentName}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="flex justify-center items-center gap-2 mt-6">
                  <input
                    type="text"
                    placeholder="Enter Document Name"
                    onChange={(e) => setPdfDocName(e.target.value)}
                    value={pdfDocName}
                    className="w-[320px] h-[36px] xl:h-[42px] 2xl:h-[42px] px-4 py-[10px] xl:py-[12px] 2xl:py-[12px] rounded-[32px] border border-solid border-[#017C57] font-[Lufga] placeholder:text-[#017C57] outline-none"
                  />
                  <div
                    className={`w-[110px] h-[36px] xl:h-[42px] 2xl:h-[42px]
  flex items-center justify-center gap-2 px-4 py-[10px]
  rounded-[100px] font-[Lufga] border-solid transition-all duration-200
  ${
    processingPdf
      ? "bg-gray-100 text-gray-500 cursor-not-allowed border-gray-300"
      : "text-[#017C57] border border-[#017C57]/60 cursor-pointer bg-transparent"
  }`}
                    onClick={() => {
                      if (processingPdf) return;

                      selectedDocuments.length === 0
                        ? toast.error("Please select at least one document.")
                        : !pdfDocName.trim()
                          ? toast.error(
                              "Please Enter PDF Name before proceeding.",
                            )
                          : generatePdfList();
                    }}
                  >
                    {processingPdf && (
                      <CircularProgress size={16} thickness={5} />
                    )}

                    <span>{processingPdf ? "Processing..." : "Download"}</span>
                  </div>
                  <div
                    className="w-[136px] h-[36px] xl:h-[42px] 2xl:h-[42px] text-white bg-[#017C57] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-normal text-[12px] leading-[16px] xl:leading-[155%] 2xl:leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]"
                    onClick={async () => {
                      await handleMapDocuments();
                    }}
                  >
                    Map
                  </div>
                  <div
                    className="w-[136px] h-[36px] xl:h-[42px] 2xl:h-[42px] text-white bg-[#017C57] px-4 py-[10px] rounded-[100px] cursor-pointer font-[Lufga] font-normal text-[12px] leading-[16px] xl:leading-[155%] 2xl:leading-[155%] tracking-[-0.07em] text-center whitespace-nowrap flex items-center justify-center border border-solid border-[#017C57]"
                    onClick={async () => {
                      const success = await handleMapDocuments();

                      if (!success) return;

                      handleMultipleDownloads(selectedDocuments);
                    }}
                  >
                    Map and Download
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default TmsQueries;
